
import { 
  Home, 
  Search, 
  Sparkles, 
  BookOpen, 
  Users, 
  Settings, 
  MessageSquare,
  FileText,
  BarChart3,
  Shield,
  Zap,
  User,
  LogOut,
  DollarSign,
  Plus
} from "lucide-react";

export interface NavItem {
  title: string;
  href: string;
  icon?: any;
  requiresAuth?: boolean;
  isPremium?: boolean;
}

export const mainNavItems: NavItem[] = [
  {
    title: "Home",
    href: "/",
    icon: Home,
  },
  {
    title: "Explore",
    href: "/explore",
    icon: Search,
  },
  {
    title: "Product Copilot",
    href: "/product-copilot",
    icon: Sparkles,
    requiresAuth: true,
    isPremium: true,
  },
  {
    title: "Resources",
    href: "/resources",
    icon: BookOpen,
  },
  {
    title: "Pricing",
    href: "/pricing",
    icon: DollarSign,
  },
  {
    title: "Submit",
    href: "/create",
    icon: Plus,
    requiresAuth: true,
  },
];

export const userNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: BarChart3,
  },
  {
    title: "Profile",
    href: "/profile",
    icon: User,
  },
  {
    title: "Settings",
    href: "/settings",
    icon: Settings,
  },
];

export const adminNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: "/admin",
    icon: BarChart3,
  },
  {
    title: "Prompts",
    href: "/admin/prompts",
    icon: FileText,
  },
  {
    title: "Users",
    href: "/admin/users",
    icon: Shield,
  },
  {
    title: "Settings",
    href: "/admin/settings",
    icon: Settings,
  },
];

export const getUserProfileUrl = (username?: string): string => {
  return username ? `/profile/${username}` : '/profile';
};
